
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { configStore } from "@/store/store";

@Component
export default class LinkChooserDialog extends Vue {
  @Prop({ default: false })
  open!: boolean;

  loading = false;

  get linkChooserUrl() {
    if (configStore.neededData) {
      return configStore.neededData.linkChooserUrl;
    }
    return "";
  }

  @Watch("open")
  onDialogUpdated() {
    if (this.open) {
      this.bindListeners();
      this.loading = true;
    } else {
      this.unbindListeners();
    }
  }

  bindListeners() {
    document.addEventListener("breakdanceLinkChooserReady", this.onDialogReady);
    document.addEventListener(
      "breakdanceLinkChooserSelect",
      this.onLinkSelected as EventListener
    );
    document.addEventListener("breakdanceLinkChooserClose", this.closeDialog);
  }

  unbindListeners() {
    document.addEventListener("breakdanceLinkChooserReady", this.onDialogReady);
    document.removeEventListener(
      "breakdanceLinkChooserSelect",
      this.onLinkSelected as EventListener
    );
    document.removeEventListener(
      "breakdanceLinkChooserClose",
      this.closeDialog
    );
  }

  onLinkSelected(event: CustomEvent) {
    this.closeDialog();

    if (event.detail) {
      this.$emit("input", event.detail.href);
    }
  }

  onDialogReady() {
    this.loading = false;
  }

  closeDialog() {
    this.$emit("close");
  }
}
